import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { KeyboardTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import ScheduleIcon from '@material-ui/icons/Schedule';
import MomentUtils from '@date-io/moment';

var TimePicker = function TimePicker(_ref) {
  var ampm = _ref.ampm,
      disabled = _ref.disabled,
      dsOnChange = _ref.dsOnChange,
      locale = _ref.locale,
      utils = _ref.utils,
      e2e = _ref.e2e,
      label = _ref.label,
      required = _ref.required,
      value = _ref.value;
  utils = utils || MomentUtils;
  return (
    /*#__PURE__*/
    // @ts-ignore
    React.createElement(MuiPickersUtilsProvider, {
      locale: locale,
      utils: utils
    }, /*#__PURE__*/React.createElement(KeyboardTimePicker, _extends({
      ampm: ampm,
      clearable: true,
      disabled: disabled,
      inputVariant: "outlined",
      keyboardIcon: /*#__PURE__*/React.createElement(ScheduleIcon, null),
      label: label,
      mask: "__:__ _M",
      onChange: dsOnChange,
      placeholder: "08:00 AM",
      required: required,
      size: "small",
      value: value
    }, e2e && {
      'data-e2e': e2e,
      inputProps: {
        'data-e2e': "".concat(e2e, "-input")
      },
      InputLabelProps: {
        'data-e2e': "".concat(e2e, "-label")
      }
    })))
  );
};

export default TimePicker;

try {
  TimePicker.__docgenInfo = {
    description: '',
    displayName: 'TimePicker',
    methods: [],
    props: {
      dsOnChange: {
        defaultValue: null,
        description: '',
        name: 'dsOnChange',
        required: true,
        type: {
          name: '(date: Moment, value?: string) => void'
        }
      },
      locale: {
        defaultValue: null,
        description: '',
        name: 'locale',
        required: false,
        type: {
          name: 'any'
        }
      },
      utils: {
        defaultValue: null,
        description: '',
        name: 'utils',
        required: false,
        type: {
          name: 'any'
        }
      },
      e2e: {
        defaultValue: null,
        description: '',
        name: 'e2e',
        required: false,
        type: {
          name: 'string'
        }
      },
      disabled: {
        defaultValue: null,
        description: 'Disable picker and text field\n' + 'If `true`, the `input` element will be disabled.',
        name: 'disabled',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      label: {
        defaultValue: null,
        description: 'The label content.',
        name: 'label',
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      value: {
        defaultValue: null,
        description: 'Picker value',
        name: 'value',
        required: true,
        type: {
          name: 'ParsableDate'
        }
      },
      required: {
        defaultValue: null,
        description: 'If `true`, the label is displayed as required and the `input` element` will be required.',
        name: 'required',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      ampm: {
        defaultValue: {
          value: 'true'
        },
        description: '12h/24h view for hour selection clock',
        name: 'ampm',
        required: false,
        type: {
          name: 'boolean'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map